import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../chronos-modal/nn-chronos-modal.js';
import '../../atoms/chronos-button/nn-chronos-button.js';

@customElement('nn-chronos-card')
export class ChronosCard extends LitElement {
  static styles = css`
    .chronos-ctn {
      align-items: center;
      background-color: white;
      border: 2px solid var(--nn-black-25, #dbdbdb);
      border-radius: 25px;
      display: flex;
      flex-direction: column;
      gap: 25px;
      justify-content: center;
      padding: 20px 40px;
    }
    .chronos__text {
      font-family: 'font-medium';
      font-size: 1.1rem;
      text-align: center;
    }
    .chronos__text--bolder b {
      font-family: 'font-heavy';
      font-weight: 400;
    }
    .chronos__button--img {
      fill: var(--nn-black, #000);
    }
    .chrn__text {
      padding: 40px;
      text-align: left;
    }
    .chrn__text--tiny-title {
      font-size: 1.4rem;
      font-weight: 600;
    }
    .chrn__text--big-title {
      font-size: 2.2rem;
      font-weight: 900;
    }
  `;

  render() {
    return html`
      <div class="chronos-ctn">
        <span class="chronos__text chronos__text--bolder">
          <b>Vous avez besoin d'aide&nbsp;?</b>
        </span>
        <span class="chronos__text chronos__text--bold">
          Nos conseillers sont à votre disposition pour vous accompagner dans
          votre prise de commande
        </span>
        <slot name="modalOpener"></slot>
      </div>
    `;
  }
}
